import router from '@/router';
import * as documentNatureConstants from "../../util/documentNatureConstants";

export const txtSolicAutorizacWS = ({ vehicle, plate, link }) => {
    return `
Estimado Cliente. 
En este *Link* encontrará el detalle de su *orden de servicio* la cual requiere *su autorización*
${link}
`.trim();
};

export const txtSolicAutInspectionWS = ({ vehicle, plate, link }) => {
    return `
Estimado Cliente. 
En este *Link* encontrará la *inspección de su vehículo* para su *aceptación* 
${link}
`.trim();
};

export const txtWaAvisoEntrega = ({
    vehicle,
    nameContact,
    nameUser,
    nameCompany
}) => {
    return `
Señor(a) ${nameContact}.
Nos complace informarle que su vehículo *${vehicle}* ya se encuentra listo para recoger.
Hemos finalizado todos los trabajos y revisiones correspondientes.
Lo esperamos en nuestras instalaciones.

¡Gracias por su confianza!
Atentamente,
${nameUser}
Asesor de servicio
${nameCompany}
`.trim();
};

export const txtNewFeaturesWS = ({ vehicle, plate, link }) => {
    return `
Estimado Cliente. 
*Hemos encontrado una novedad y requerimos su autorización.*
En este *Link* encontrará el detalle de la novedad la cual requiere su autorización
${link}
`.trim();
};

export const calculateDVByNit = myNit => {
    // Limpieza
    myNit = String(myNit)
        .replace(/\s/g, "")
        .replace(/,/g, "")
        .replace(/\./g, "")
        .replace(/-/g, "");

    if (isNaN(myNit) || myNit === "") {
        console.log("El NIT/cédula no es válido:", myNit);
        return null; // o ""
    }

    const vpri = [0, 3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71]; // índice 0 no usado

    let x = 0;
    const z = myNit.length;

    for (let i = 0; i < z; i++) {
        const y = parseInt(myNit.substr(z - 1 - i, 1), 10); // de derecha a izquierda
        x += y * vpri[z - i];
    }

    const y = x % 11;

    const dv = y > 1 ? 11 - y : y;

    return dv;
};

export function getRouteMeta(key, default_value) {
    return router.currentRoute.meta[key] || default_value;
}

export function isDocumentNature(code, group = 'sale') {
    const documentNatureGroups = {
        sale: [
            '02',
            documentNatureConstants.CODE_NATURALEZA_ORDEN_SERVICIO,
            documentNatureConstants.CODE_NATURALEZA_VENTAS,
            documentNatureConstants.CODE_NATURALEZA_REMISION_VENTAS_FACT,
            '08',
            documentNatureConstants.CODE_NATURALEZA_DEVOL_VENTAS,
            documentNatureConstants.CODE_NATURALEZA_ANULACION_REMIS_VENTA,
            '23'
        ],

        buy: [
            '06',
            documentNatureConstants.CODE_NATURALEZA_COMPRAS,
            documentNatureConstants.CODE_NATURALEZA_DEVOL_COMPRAS,
            '09',
            documentNatureConstants.CODE_NATURALEZA_REMISION_COMPRAS,
            documentNatureConstants.CODE_NATURALEZA_GASTOS
        ]
    };

    return documentNatureGroups[group] &&
        documentNatureGroups[group].includes(code);
}

export const isTallerServitecaAndServicioAutYamaha = (
    subscriberData = null
) => {
    const subscriber = subscriberData || JSON.parse(localStorage.subscriber);

    if (!subscriber || !subscriber.company_type_parameter) {
        return false;
    }

    if (!subscriber || !subscriber.sub_company_type) {
        return false;
    }

    const isTallerServiteca =
        subscriber.company_type_parameter.name_parameter === "TALLER-SERVITECA";
    const isServicioAutYamaha =
        subscriber.sub_company_type.name_parameter === "SERVICIO AUT (YAMAHA)";

    return isTallerServiteca && isServicioAutYamaha;
};



// WEBPACK FOOTER //
// ./src/point_of_sale/utils/utils.js